import { Task } from '@/shared/model/resolution/task.model';

export const enum ResolutionStatus {
  NEW = 'NEW',
  DELETED = 'DELETED',
}

export const enum ResolutionSourceType {
  DOC = 'DOC',
  TASK_RECEIVED = 'TASK_RECEIVED',
}

export const enum ResolutionType {
  CHANCELLERY_CONFIRM_RESOLUTION = 'CHANCELLERY_CONFIRM_RESOLUTION',
  CHANCELLERY_RESOLUTION = 'CHANCELLERY_RESOLUTION',
  LEADER_RESOLUTION = 'LEADER_RESOLUTION',
  INTERNAL_RESOLUTION = 'INTERNAL_RESOLUTION',
  RECEIVED_ANSWER = 'RECEIVED_ANSWER',
  DOC_FLOW_RESOLUTION = 'DOC_FLOW_RESOLUTION',
  FORWARDED_RESOLUTION = 'FORWARDED_RESOLUTION',
}

export interface IResolution {
  id?: number;
  code?: string;
  sortOrder?: number;
  status?: ResolutionStatus;
  sourceType?: ResolutionSourceType;
  type?: ResolutionType;
  sourceValue?: number;
  docId?: number;
  docJournalId?: number;
  taskList?: Task[];
  sentLeader?: boolean;
  leaderJobId?: number;
  leaderEmployeeId?: number;
  previousTaskDeadlineDateStr?: string;
  branchId?: number;
}

export class Resolution implements IResolution {
  constructor(
    public id?: number,
    public code?: string,
    public sortOrder?: number,
    public status?: ResolutionStatus,
    public sourceType?: ResolutionSourceType,
    public type?: ResolutionType,
    public sourceValue?: number,
    public taskList?: Task[],
    public docId?: number,
    public docJournalId?: number,
    public sentLeader?: boolean,
    public leaderJobId?: number,
    public leaderEmployeeId?: number,
    public previousTaskDeadlineDateStr?: string,
    public branchId?: number
  ) {
    this.sentLeader = true;
    this.status = ResolutionStatus.NEW;
    this.taskList = [];
  }
}
